import { lazy } from "react";

export const AlertHistoryPage = lazy(() => import("./../pages/AlertHistory/AlertHistory"));
export const AlertManagementPage = lazy(() => import("./../pages/AlertManagement/AlertManagement"));
export const ClientManagementPage = lazy(() => import("./../pages/ClientManagement/ClientManagement"));
export const AllZonesDashboardPage = lazy(() => import("./../pages/Dashboard/Dashboard"));
export const DashboardSummaryPage = lazy(() => import("./../pages/Dashboard/DashboardSummary"));
export const InstallerMenuPage = lazy(() => import("./../pages/InstallerMenu/InstallerMenu"));
export const LoginPage = lazy(() => import("./../pages/Login/Login"));
export const ReportPage = lazy(() => import("./../pages/Report/Report"));
export const SingleSensorPage = lazy(() => import("../pages/Dashboard/SingleSensor/SingleSensor"));
